"use client";

import CTA from "@/components/CTA";
import ToFAQ from "@/components/Category/ToFAQ";
import { site } from "@/data/default";
import { ReactNode } from "react";

const laptopKarawang: ReactNode = (
  <>
    <section className="mb-6">
      <h2 className="text-xl font-bold mb-2">Kenapa Sewa Laptop Karawang Sekarang Jadi Kebutuhan Primer?</h2>
      <p className="mb-4">
        Karawang hari ini bukan cuma jantung industri nasional, tapi juga medan produktivitas digital yang terus bergerak cepat.
        Dari ruang kantor di kawasan <strong>KIIC, KIM, hingga Surya Cipta</strong>, sampai ke pelatihan komunitas desa wisata seperti <strong>Loji, Puseurjaya, dan Curug</strong>,
        kebutuhan akan <strong>sewa laptop Karawang</strong> makin terasa nyata, lebih hemat, lebih praktis, tanpa biaya perawatan.
      </p>
    </section>

    <section className="grid gap-6">
      <div className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <h3 className="font-semibold text-lg mb-2">Laptop Berbagai Spek: Core i5, RAM 8GB, SSD Cepat</h3>
        <p className="text-sm">
          Tak semua pekerjaan butuh laptop mahal. Tapi semua pekerjaan butuh laptop yang tepat. Kami sediakan <strong>sewa laptop Karawang</strong>
          dari spek ringan untuk input data hingga spek tinggi buat rendering & editing. Mulai dari brand seperti HP, Lenovo, Acer, ASUS, semua tersedia.
        </p>
      </div>

      <div className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <h3 className="font-semibold text-lg mb-2">Dari Harga Harian sampai Paket Bulanan, Fleksibel Banget</h3>
        <p className="text-sm">
          Harga <strong>sewa laptop Karawang</strong> bisa kamu atur sendiri. Butuh harian untuk event atau mingguan buat training? Bisa.
          Bahkan kami kasih diskon spesial untuk penyewaan bulanan, cocok buat operasional proyek atau event pemerintah.
        </p>
      </div>

      <div className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <h3 className="font-semibold text-lg mb-2">Gratis Ongkir ke Pusat Kota, Karawang Barat, hingga Galuh Mas</h3>
        <p className="text-sm">
          Kami layani <strong>sewa laptop Karawang</strong> dengan sistem antar-jemput. Khusus Karawang Kota, Telukjambe, atau daerah Galuh Mas,
          biaya antar jemput kami gratiskan. Ke lokasi industri juga bisa, dengan logistik cepat & transparan.
        </p>
      </div>

      <div className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <h3 className="font-semibold text-lg mb-2">Laptop Sudah Siap Pakai: Office, Zoom, Google Drive</h3>
        <p className="text-sm">
          Setiap unit <strong>laptop sewaan Karawang</strong> kami sudah siap pakai: tinggal nyalakan, login, dan kerja.
          Cocok untuk seminar, pelatihan, pameran, atau operasional harian, tanpa perlu ribet install ini-itu lagi.
        </p>
      </div>

      <div className="bg-white shadow-md rounded-xl p-5 border border-gray-200">
        <h3 className="font-semibold text-lg mb-2">Support Langsung Saat Ada Kendala, Ganti Unit Tanpa Drama</h3>
        <p className="text-sm">
          Di tengah acara tiba² laptop ngadat? Kami siaga. Tim support <strong>sewa laptop Karawang</strong> bisa langsung kirim unit pengganti hari itu juga,
          agar event atau pelatihanmu tetap berjalan tanpa hambatan.
        </p>
      </div>
    </section>

    <section className="mt-10">
      <h2 className="text-xl font-bold mb-3">Laptop untuk Segala Tipe Kebutuhan: Entry, Mid, hingga High Spec</h2>
      <p className="mb-4">
        Dari pelatihan Excel untuk staff administrasi, sampai rendering 3D buat arsitek lapangan,
        kami punya pilihan <strong>laptop rental Karawang</strong> sesuai kebutuhan. Tersedia Core i3 untuk tugas ringan,
        Core i5 & i7 untuk multitasking berat, serta GPU NVIDIA untuk kebutuhan desain.
      </p>
    </section>

    <section className="mt-10">
      <h2 className="text-xl font-bold mb-3">Pengiriman Cepat ke Telukjambe, hingga Karawang Timur</h2>
      <p className="mb-4">
        Kami tak hanya kirim ke pusat kota. Daerah pinggiran Karawang seperti <strong>Telukjambe Timur, atau Cikampek</strong>,
        semua bisa dijangkau. Bahkan ke lokasi proyek atau tempat wisata yang sulit dijangkau vendor lain, tetap bisa kami antar.
      </p>
    </section>

    <section className="mt-10">
      <h2 className="text-xl font-bold mb-3">Garansi Maintenance & Dukungan Penuh Selama Masa Sewa</h2>
      <p className="mb-4">
        Kami tak lepas tangan setelah unit dikirim. Selama masa <strong>sewa laptop Karawang</strong>, kamu dapat bantuan teknis, maintenance ringan,
        dan pembaruan sistem kalau dibutuhkan. Kamu tinggal fokus ke kegiatanmu, urusan teknis biar kami yang urus.
      </p>
    </section>

    <CTA
      title="Siap Kerja Editing & Olah Data Dimana² Bosku?"
      description="🚚 Butuh sewa laptop terdekat sekarang juga? Chat tim kami sekarang. <br />Kapan pun, di mana pun, selama unit ready, kami kirim hari itu juga."
      buttonText="Booking Laptop Sekarang"
      onClick={() => {
        window.open(
          `https://wa.me/${site.whatsapp}?text=Halo%2C%20saya%20ingin%20booking%20laptop.%20Lokasi%20dan%20tanggal%20sudah%20siap.`,
          "_blank"
        );
      }}
    />

    <ToFAQ category="Laptop" />
  </>
);

export default laptopKarawang;